export function singlePostScript() {
  if (!document.body.classList.contains('single-post')) {
    return;
  }
  
  const copyButtons = document.querySelectorAll('.copy-link');
  const copiedTexts = document.querySelectorAll('.copied-text');
  
  if (copyButtons.length === 0 || copiedTexts.length === 0) return;
  
  copyButtons.forEach((copyButton, index) => {
    const copiedText = copiedTexts[index];
    
    if (!copiedText) return;
    
    copyButton.addEventListener('click', (event) => {
      event.preventDefault();
      navigator.clipboard.writeText(window.location.href).then(() => {
        copiedText.classList.add('active');
        setTimeout(() => {
          copiedText.classList.remove('active');
        }, 3000);
      });
    });
  });
}
